
import { Component,Prop,Watch, BaseMixins } from '@/lib';
@Component
export default class HiBase extends BaseMixins {
  @Prop({ type: String, default: "8" }) span: string; //栅格size
  @Prop({ type: Number, default: 0 }) offset: number;
}
